import Vue from 'vue';
import Router from 'vue-router';
import store from './store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue'),
    },
    {
      path: '/manifesto',
      name: 'manifesto',
      component: () => import('./views/Manifesto.vue'),
    },
    {
      path: '/esposizione',
      name: 'archive',
      component: () => import('./views/Archive.vue'),
    },
    {
      path: '/esposizione/:id',
      name: 'motorcycle',
      component: () => import('./views/Motorcycle.vue'),
    },
    {
      path: '/contatti',
      name: 'contact',
      component: () => import('./views/Contact.vue'),
    },
    {
      path: '/thank-u',
      name: 'thank-u',
      component: () => import('./views/Thanku.vue'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (store.state.menu) store.commit('TOGGLE_MENU');

  if (!store.state.firebase) {
    store.dispatch('LOAD_DATA').then(() => {
      document.querySelector('.pointer__wrapper').dataset.page = to.name;
      next();
    });
  } else {
    document.querySelector('.pointer__wrapper').dataset.page = to.name;
    next();
  }
});

export default router;
